import { Environments } from '@/config';
import { HELIX_RENOWN_PRODUCTION } from './helix-renown.production';
import { HELIX_RENOWN_STAGING } from './helix-renown.staging';

export const HELIX_RENOWN = import.meta.env.MODE === Environments.PROD ? HELIX_RENOWN_PRODUCTION : HELIX_RENOWN_STAGING;
